// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","subscriptionDetail":"subscriptionDetail-2gC2z","subscriptionDetail__label":"subscriptionDetail__label-3M7zT"};